<template>
  <div class="to-do__wrapper">
    <ToDoView
      :selectedToDoInList="selectedToDoInList"
      @addToDo="onShowAddToDo"
      @onHideToDoWidget="onHideToDoWidget"
    />
    <ToDoAdd
      v-if="addToDo"
      id="to-do-add"
      className="to-do__edit"
      @onCancel="onCloseAddAddToDo"
      @onCloseWidget="onHideToDoWidget"
    />
    <button
      v-if="showCloseButton"
      class="to-do-widget__close"
      @click.prevent="onHideToDoWidget"
    >
      <icon
        data="@icon/close.svg"
        :fill="false"
        width="var(--icon-24)"
        height="var(--icon-24)"
      />
    </button>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Emit, Prop } from "vue-property-decorator"
import { gsap } from "gsap"
import { Action, Getter } from "s-vuex-class"

import ToDoAdd from "@/components/ToDo/ToDoAdd.vue"
import ToDoView from "@/components/ToDo/ToDoView.vue"

import { ToDo } from "@/models/ToDo"
import { Actions } from "@/store"
import { Getters } from "@/store/getters"

const components = {
  ToDoView,
  ToDoAdd
}

@Options({
  name: "ToDoComponent",
  components
})
export default class ToDoComponent extends Vue {
  @Prop() readonly selectedToDoInList: ToDo

  @Getter(Getters.GET_TODO) readonly toDo: ToDo

  @Action(Actions.ADD_FILE_BY_ACCOUNT) addFileByAccount: (fileByAccount: boolean) => void
  @Action(Actions.RESET_TO_DO) resetToDo: () => void

  @Prop({ default: false }) showCloseButton: boolean

  addToDo = false
  created() {
    this.addToDo = this.toDo.addMode
    this.addFileByAccount(true)
  }

  async onShowAddToDo() {
    this.addToDo = true
    await this.$nextTick()
    this.animateScale(0, 1)
  }

  onCloseAddAddToDo() {
    this.animateScale(1, 0, () => {
      this.resetToDo()
      this.addToDo = false
    })
  }

  /** Scales Add ToDo from its button and reverses the same animation on Back. */
  animateScale(from: number, to: number, onComplete?: () => void) {
    const addRect = document.getElementById("to-do-add")!.getBoundingClientRect()
    const buttonRect = document.getElementById("to-do-add-button")!.getBoundingClientRect()

    gsap.fromTo(
      "#to-do-add",
      {
        scale: from,
        transformOrigin: `${buttonRect.left + buttonRect.width / 2 - addRect.left}px ${
          buttonRect.top + buttonRect.height / 2 - addRect.top
        }px`
      },
      {
        scale: to,
        duration: 0.3,
        ease: to ? "power3.out" : "power3.in",
        onComplete
      }
    )
  }

  @Emit()
  onHideToDoWidget() {
    return
  }

  beforeUnmount() {
    this.addFileByAccount(false)
  }
}
</script>
